import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConnected: false,
};

const slice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnected: (state, action) => {
      state.isConnected = action.payload;
    },
  },
});

export const { setConnected } = slice.actions;

export const selectIsConnected = (state) => state.connection.isConnected;

export default slice.reducer;
